module.exports = __webpack_public_path__ + "static/media/stacked_charts.06dd4006.png";